module.exports = __webpack_public_path__ + "media/country_flags/er-3bf26e30.png";